export default "__VITE_ASSET__Fc$3TRhU__"